import React, { useEffect, useState } from "react"; // <-- now includes useState for ServicePayGuard
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom"; // Import Navigate for redirection
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer,toast } from "react-toastify"; // Import ToastContainer
import "./style.css"; // Import Tailwind CSS
import axios from "axios";

import Login from "./Auth/Login";
import OtpVerification from "./Auth/OtpVerification";
import Registration from "./Auth/Registration";
import ForgotPassword from "./Auth/ForgotPassword";
import Logout from "./Auth/Logout";
import Home from "./Landlord/home";
import Profile from "./Landlord/profile";
import PropertyPage from "./Landlord/propertypage";
import UpdateProperty from "./Landlord/updateproperty";
import WithdrawalsPage from "./Landlord/withdrawals";
import CommentsPage from "./Landlord/comments";
import ReservationsPage from "./Landlord/reservations";
import AmenitiesPage from "./Landlord/amenities";
import UpdateAmenity from "./Landlord/updateamenity";
import Rentals from "./Landlord/rentals";
import UpdateRental from "./Landlord/updaterental";
import SpecificRental from "./Landlord/specificrental";
import DeletePhoto from "./Landlord/deletephoto";
import DeleteVideo from "./Landlord/deletevideo";
import WaterUnitsPage from "./Landlord/waterunits";
import UpdateWaterUnitsPage from "./Landlord/waterunitsupdate";
import CaretakersPage from "./Landlord/caretaker";
import RegisterCaretaker from "./Landlord/registercaretaker";
import DeleteCaretaker from "./Landlord/deletecaretaker";
import MaintenancePage from "./Landlord/maintenance";
import UpdateMaintenancePage from "./Landlord/updatemaintenance";
import VacatingPage from "./Landlord/vacating";
import UpdateVacatingPage from "./Landlord/updatevacating";
import PropertyKYCPage from "./Landlord/propertykyc";
import AddPropertyKYCPage from "./Landlord/addkyc";
import BillsPage from "./Landlord/bills";
import DepositsPage from "./Landlord/deposits";
import NotificationsPage from "./Landlord/notifications";
import RecordsPage from "./Landlord/recordsview";
import TransactionsViewPage from "./Landlord/transactionsview";
import Settlement from "./Landlord/settlement";
import BankDetailsPage from "./Landlord/account";
import TransactionC2BStatsView from "./Landlord/payinsstatistics";
import TrashUnitsPage from "./Landlord/checktrashprice";
import UpdateTrashUnitsPage from "./Landlord/trashunitsupdate";
import MoneyStatistics from "./Landlord/moneystatistics";
import ArchivedData from "./Landlord/archiveddatarecords";
import ArchivedDataSettlements from "./Landlord/archiveddatasettlement";
import ArchivedDataTransactions from "./Landlord/archiveddatatransactions";
import PendingPayments from "./Landlord/pendingpayment";
import TransactionB2CStatsView from "./Landlord/payoutsstatistics";
import SMSSetting from "./Landlord/smssetting";
import MpesaSettings from "./Landlord/mpesasetting";
import ChangePasswordPage from "./Landlord/changepassword";
import SendSMSPage from "./Landlord/sendsms";
import ServiceChargePaymentPage from "./Landlord/servicechargepayment";
import OfflinePayments from "./Landlord/offline";


// Define your global base URL here
export const StandardURL = "https://backend.inyumba.co.ke";

function App() {
  return (
    <Router>
      <Routes>
        {/* Routes accessible whether user is logged in or not */}
        <Route path="/" element={<Login />} />
        <Route path="/OtpVerification" element={<OtpVerification />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/logout" element={<Logout />} />
        {/* Routes accessible only when user is logged in */}
        <Route path="/landlord/home" element={<Home />} />
        <Route path="/landlord/profile" element={<Profile />} />
        <Route path="/landlord/propertypage" element={<ServicePayGuard>
              <PropertyPage/></ServicePayGuard> } />
        <Route path="/landlord/updateproperty" element={<ServicePayGuard>
              <UpdateProperty/></ServicePayGuard>} />
        <Route path="/landlord/withdrawals" element={<ServicePayGuard>
              <WithdrawalsPage/></ServicePayGuard>} />
        <Route path="/landlord/deposits" element={<ServicePayGuard>
              <DepositsPage/></ServicePayGuard>} />
        <Route path="/landlord/comments" element={<ServicePayGuard>
              <CommentsPage/></ServicePayGuard>} />
        <Route path="/landlord/vacating" element={<ServicePayGuard>
              <VacatingPage/></ServicePayGuard>} />
        <Route
          path="/landlord/updatevacating"
          element={<ServicePayGuard>
              <UpdateVacatingPage/></ServicePayGuard>}
        />
        <Route path="/landlord/caretaker" element={<ServicePayGuard>
              <CaretakersPage/></ServicePayGuard>} />
        <Route
          path="/landlord/registercaretaker"
          element={<ServicePayGuard>
              <RegisterCaretaker/></ServicePayGuard>}
        />
        <Route path="/landlord/deletecaretaker" element={<ServicePayGuard>
              <DeleteCaretaker/></ServicePayGuard>} />
        <Route path="/landlord/maintenance" element={<ServicePayGuard>
              <MaintenancePage/></ServicePayGuard>} />
        <Route
          path="/landlord/updatemaintenance"
          element={<ServicePayGuard>
              <UpdateMaintenancePage/></ServicePayGuard>}
        />
        <Route path="/landlord/reservations" element={<ServicePayGuard>
              <ReservationsPage/></ServicePayGuard>} />
        <Route path="/landlord/propertykyc" element={<ServicePayGuard>
              <PropertyKYCPage/></ServicePayGuard>} />
        <Route
          path="/landlord/addpropertykyc"
          element={<ServicePayGuard>
              <AddPropertyKYCPage/></ServicePayGuard>}
        />
        <Route path="/landlord/waterunits" element={<ServicePayGuard>
              <WaterUnitsPage/></ServicePayGuard>} />
        <Route path="/landlord/amenities" element={<ServicePayGuard>
              <AmenitiesPage/></ServicePayGuard>} />
        <Route path="/landlord/rentals" element={<ServicePayGuard>
              <Rentals/></ServicePayGuard>} />
        <Route path="/landlord/updateamenity" element={<ServicePayGuard>
              <UpdateAmenity/></ServicePayGuard>} />
        <Route path="/landlord/updaterental" element={<ServicePayGuard>
              <UpdateRental/></ServicePayGuard>} />
        <Route path="/landlord/specificrental" element={<ServicePayGuard>
              <SpecificRental/></ServicePayGuard>} />
        <Route path="/landlord/deletephoto" element={<ServicePayGuard>
              <DeletePhoto/></ServicePayGuard>} />
        <Route path="/landlord/deletevideo" element={<ServicePayGuard>
              <DeleteVideo/></ServicePayGuard>} />
        <Route
          path="/landlord/updatewaterunits"
          element={<ServicePayGuard>
              <UpdateWaterUnitsPage/></ServicePayGuard>}
        />
        <Route path="/landlord/bills" element={<ServicePayGuard>
              <BillsPage/></ServicePayGuard>} />
        <Route path="/landlord/notifications" element={<ServicePayGuard>
              <NotificationsPage/></ServicePayGuard>} />
        <Route path="/landlord/recordsview" element={<ServicePayGuard>
              <RecordsPage/></ServicePayGuard>} />
        <Route
          path="/landlord/transactionsview"
          element={<ServicePayGuard>
              <TransactionsViewPage/></ServicePayGuard>}
        />
        <Route path="/landlord/settlement" element={<ServicePayGuard>
              <Settlement/></ServicePayGuard>} />
        <Route path="/landlord/account" element={<ServicePayGuard>
              <BankDetailsPage/></ServicePayGuard>} />
        <Route
          path="/landlord/payinsstatistics"
          element={<ServicePayGuard>
              <TransactionC2BStatsView/></ServicePayGuard>}
        />
        <Route
          path="/landlord/payoutsstatistics"
          element={<ServicePayGuard>
              <TransactionB2CStatsView/></ServicePayGuard>}
        />
        <Route path="/landlord/checktrashprice" element={<ServicePayGuard>
              <TrashUnitsPage/></ServicePayGuard>} />
        <Route
          path="/landlord/trashunitsupdate"
          element={<ServicePayGuard>
              <UpdateTrashUnitsPage/></ServicePayGuard>}
        />
        <Route path="/landlord/moneystatistics" element={<ServicePayGuard>
              <MoneyStatistics/></ServicePayGuard>} />
        <Route
          path="/landlord/archiveddatarecords"
          element={<ServicePayGuard>
              <ArchivedData/></ServicePayGuard>}
        />
        <Route
          path="/landlord/archiveddatasettlement"
          element={<ServicePayGuard>
              <ArchivedDataSettlements/></ServicePayGuard>}
        />
        <Route
          path="/landlord/archiveddatatransactions"
          element={<ServicePayGuard>
              <ArchivedDataTransactions/></ServicePayGuard>}
        />

        <Route
          path="/landlord/pendingpayment"
          element={<ServicePayGuard>
              <PendingPayments/></ServicePayGuard>}
        />


        <Route
          path="/landlord/smssetting"
          element={<ServicePayGuard>
              <SMSSetting/></ServicePayGuard>}
        />

        <Route
          path="/landlord/mpesasetting"
          element={<ServicePayGuard>
              <MpesaSettings/></ServicePayGuard>}
        />

        <Route
          path="/landlord/changepassword"
          element={<ServicePayGuard>
              <ChangePasswordPage/></ServicePayGuard>}
        />

        <Route
          path="/landlord/sendsms"
          element={<ServicePayGuard>
              <SendSMSPage/></ServicePayGuard>}
        />

         <Route
          path="/landlord/servicechargepayment"
          element={<ServiceChargePaymentPage />}
        />

        <Route
          path="/landlord/offline"
          element={<ServicePayGuard>
              <OfflinePayments/></ServicePayGuard>}
        />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <ToastContainer />
    </Router>
  );
}

export default App;

export function AuthGuard({ children }) {
  const navigate = useNavigate();
  useEffect(() => {
    // Retrieve the JSON string from localStorage
    const userDataString = localStorage.getItem("user");

    try {
      // Parse the JSON string to convert it into a JavaScript object
      const userData = JSON.parse(userDataString);
      // Access the 'unique' property from the 'user' object
      const userId = userData.unique;

      if (!userId) {
        navigate("/");
      }
    } catch (error) {
      navigate("/");
    }
  }, []);

  return <>{children}</>;
}

export function TokenGuard({ children }) {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    }
  }, []);

  return <>{children}</>;
}


export function RoleGuard({ children }) {
  const navigate = useNavigate();

  useEffect(() => {
    const userDataString = localStorage.getItem("user");

    try {
      const userData = JSON.parse(userDataString);
      const userRole = userData?.role;

      if (!["ADMIN", "BUSINESS"].includes(userRole)) {
        navigate("/");
      }
    } catch (error) {
      navigate("/");
    }
  }, [navigate]);

  return <>{children}</>;
}


export function ServicePayGuard({ children }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkPaymentStatus = async () => {
      setIsLoading(true);

      const token = localStorage.getItem("token");
      const propertyId = localStorage.getItem("selectedPropertyId");

      if (!token) {
        toast.error("Authentication required to access this page. 🔑");
        navigate("/", { replace: true });
        return;
      }

      if (!propertyId) {
        toast.error("No property selected. Please select a property first. ⚠️");
        navigate("/landlord/home", { replace: true });
        return;
      }

      try {
        const apiUrl = `${StandardURL}/iNyumba/serviceratecharge/fetchindividualservicepaymentstatus/${propertyId}`;
        const response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data.response === "inactive") {
          toast.warn("Your service charge payment is inactive. Please pay to continue. 🚨");
          navigate("/landlord/servicechargepayment", { replace: true });
          return;
        }
      } catch (error) {
        console.error("❌ API error:", error);
        const errorMessage = error.response?.data?.response || "Failed to verify service payment status. ❌";
        toast.error(errorMessage);
        navigate("/landlord/servicechargepayment", { replace: true });
        return;
      } finally {
        setIsLoading(false);
      }
    };

    checkPaymentStatus();
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-50 z-50">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
        <p className="text-gray-700 text-lg font-medium">
          Verifying service payment...
        </p>
        <p className="text-gray-500 text-sm mt-1">
          Please wait while we confirm your access.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}

